import { render, staticRenderFns } from "./UnsuspensionNotActionable.vue?vue&type=template&id=185dec5f&"
import script from "./UnsuspensionNotActionable.vue?vue&type=script&lang=js&"
export * from "./UnsuspensionNotActionable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports